import React from "react";

const MainemployeePrint = () => {
  return (
    <>
      <div id="printt">
        <h3 className="text-center m-3">بيانات التوكيل</h3>
        <p>
          <span>اسم الموكل: </span>
         asd
        </p>
        <p>
          <span>صفة الموكل: </span>
         asd
        </p>
        <p>
          <span>اسم الوكيل: </span>
        asd
        </p>
        <p>
          <span>رقم التوكيل: </span>
         asd
        </p>
        <p>
          <span>نوع التوكيل: </span>
          asd
        </p>
        <p>
          <span>جهة التوثيق: </span>
        asd
        </p>
        <p>
          <span>تاريخ التوكيل: </span>
          {new Date('asd').toLocaleDateString("en-GB")}
        </p>
        <p>
          <span>الغرض من التوكيل: </span>
       asd
        </p>
        <p>
          <span>حالة التوكيل: </span>
    asd
        </p>
      </div>
    </>
  );
};

export default MainemployeePrint;
